import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { TranslocoDirective } from '@jsverse/transloco';
import { SignInComponent } from '../sign-in/sign-in.component';
import { TertiaryButtonComponent } from '../../shared/buttons/tertiary-button.component';
import { LinkButtonComponent } from '../../shared/buttons/link-button.component';

@Component({
  selector: 'sibat-sign-in-page',
  template: `
    <section *transloco="let t; read: 'authentication'">
      <article>
        <header>
          <h1>{{ t('authenticate') }}</h1>
        </header>
        <div class="part">
          <h2>{{ t('ecab_internal') }}</h2>
          <a [href]="getOpenIdUrl()" class="button button-red" data-cy="btn-entra-id">ECAB</a>
          <p>
            {{ t('connexion_issue') }}
          </p>
        </div>
        <div class="part">
          <h2>{{ t('ecab_external') }}</h2>
          <sibat-signin></sibat-signin>

          <article>
            <header>
              <h1>{{ t('firstAccess') }}</h1>
            </header>
            <p>
              <sibat-tertiary-button (clicked)="firstAccess()" [label]="t('clickHere')"> </sibat-tertiary-button>
            </p>
          </article>
          <hr />
          <article>
            <p>
              {{ t('noAccount') }}&nbsp;
              <sibat-link-button [href]="supportEmail" [label]="t('contactUs')" [external]="true"> </sibat-link-button>
            </p>
          </article>
        </div>
      </article>
    </section>
  `,
  styleUrls: ['../css/authentication.scss', 'sign-in-page.component.scss'],
  imports: [TranslocoDirective, SignInComponent, TertiaryButtonComponent, LinkButtonComponent],
})
export class SignInPageComponent {
  supportEmail = `mailto:${environment.supportEmail}`;

  constructor(private router: Router) {}

  firstAccess() {
    this.router.navigate(['/forgotPassword']);
  }

  getOpenIdUrl() {
    if (environment.version === 'DEV') {
      return 'http://localhost:8080/oauth2/authorization/entra-id';
    }

    return '/oauth2/authorization/entra-id';
  }
}
